import React, { useState, useEffect, useRef } from 'react';
import "../css/dpi-styles.css";

const Test = () => {
  const [isPalletVisible, setPalletVisible] = useState(false); // Manage visibility
  const [text, setText] = useState(''); // Store the input text
  const comboRef = useRef(); // Reference to input field

  // Handle key press and check for "@" character
  const handleKeyPress = (e) => {
    if (e.key === "@") {
      setPalletVisible(true);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    setText(e.target.value);
  };

  // Detect keypress inside the input field
  useEffect(() => {
    const inputElement = comboRef.current;
    inputElement.addEventListener("keypress", handleKeyPress);
    return () => {
      inputElement.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  return (
    <div>
      <h3>Type "@" to open combo pallet</h3>
      <input
        type="text"
        value={text}
        onChange={handleChange}
        ref={comboRef}
        placeholder="Type something..."
      />

      {isPalletVisible && (
        <div className="combo-pallet">
          <ul>
            <li>Option 1</li>
            <li>Option 2</li>
            <li>Option 3</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Test;
